var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';
import Menu from '@arco-design/web-react/es/Menu';
import Button from '@arco-design/web-react/es/Button';
import { IconDown, IconClose } from '@arco-design/web-react/icon';
import Dropdown from '@arco-design/web-react/es/Dropdown';
import elementInContainer from '../utils/element-in-container';
var AllName = 'All';
var CustomizeName = 'Customize';
var BtnName = 'filter-title-btn';
var AciveItemClassName = 'active';
export default function SingleFilter(props) {
    var label = props.label, disabled = props.disabled, onSelect = props.onSelect, triggerStyle = props.triggerStyle, dropListStyle = props.dropListStyle, _a = props.type, type = _a === void 0 ? 'single' : _a, _b = props.maxHeight, maxHeight = _b === void 0 ? 300 : _b, _c = props.dataSource, dataSource = _c === void 0 ? [] : _c, _d = props.title, title = _d === void 0 ? 'Filter' : _d, _e = props.allName, allName = _e === void 0 ? AllName : _e, iconDownClassName = props.iconDownClassName, _f = props.iconDownStyle, iconDownStyle = _f === void 0 ? {} : _f, _g = props.checkedValues, checkedValues = _g === void 0 ? [] : _g, _h = props.defaultPopupVisible, defaultPopupVisible = _h === void 0 ? false : _h, _j = props.customizeName, customizeName = _j === void 0 ? CustomizeName : _j;
    var _k = useState(false), showClear = _k[0], setShowClear = _k[1];
    var _l = useState(checkedValues[0]), selectedItem = _l[0], setSelectedItem = _l[1];
    var _m = useState(checkedValues[0]), interSelectedItem = _m[0], setInterSelectedItem = _m[1];
    var _o = useState(defaultPopupVisible), popupVisible = _o[0], setPopupVisible = _o[1];
    function clickPopupHandle(e) {
        var target = e.target;
        if (popupVisible
            && (!elementInContainer(target, BtnName, btnRef.current)
                && !elementInContainer(target, 'arco-trigger'))
            || elementInContainer(target, 'close-popup')) {
            popupVisibleHandle(false);
        }
    }
    useEffect(function () {
        window.addEventListener('click', clickPopupHandle);
        return function () { return window.removeEventListener('click', clickPopupHandle); };
    }, [popupVisible]);
    useEffect(function () {
        if (selectedItem) {
            dataSource.forEach(function (item) {
                if (isEqual(item.value, selectedItem.value)) {
                    setSelectedItem(item);
                }
            });
        }
    }, [dataSource]);
    useEffect(function () {
        setSelectedItem(checkedValues[0]);
    }, [checkedValues]);
    function selecthandle(item, inter) {
        if (inter === void 0) { inter = false; }
        if (!inter) {
            setSelectedItem(item);
            onSelect && onSelect(item);
        }
        setInterSelectedItem(item);
    }
    function popupVisibleHandle(value) {
        setPopupVisible(value);
        setInterSelectedItem(selectedItem);
    }
    function isActive(item) {
        if (!interSelectedItem && !item) {
            return AciveItemClassName;
        }
        return interSelectedItem && interSelectedItem.name === (item && item.name)
            ? AciveItemClassName : '';
    }
    function getCustomChild(element, item) {
        if (typeof element === 'function') {
            return element(item);
        }
        return element;
    }
    var btnRef = useRef(null);
    var isSelect = type === 'select';
    var showIconClose = !isSelect && selectedItem && showClear;
    var showIconDown = isSelect || (!selectedItem || (selectedItem && !showClear));
    var dropList = (React.createElement(Menu, { className: "drop-list", style: __assign(__assign({ maxHeight: maxHeight }, (isSelect ? { minWidth: 0 } : {})), dropListStyle) }, dataSource.map(function (item, index) {
        if (item.name === allName) {
            return (React.createElement(Menu.Item, { key: "-1", onClick: function () {
                    selecthandle();
                    popupVisibleHandle(false);
                }, className: isActive() }, item.name));
        }
        if (item.name === customizeName) {
            return (React.createElement("div", { key: "-2" },
                React.createElement(Menu.Item, { key: "-3", onClick: function () { return selecthandle(item, true); }, className: isActive(item) }, item.name),
                isActive(item) && getCustomChild(item.element, __assign(__assign({}, item), { setState: setSelectedItem }))));
        }
        return (React.createElement(Menu.Item, { key: String(index), onClick: function () {
                selecthandle(item);
                popupVisibleHandle(false);
            }, className: isActive(item) }, item.name));
    })));
    return (React.createElement(Dropdown, __assign({}, props, { droplist: dropList, position: "bl", popupVisible: popupVisible, trigger: "click" }),
        React.createElement(Button, { ref: btnRef, type: "text", disabled: disabled, style: triggerStyle, onMouseEnter: function () { return setShowClear(true); }, onMouseLeave: function () { return setShowClear(false); }, onClick: function () { return popupVisibleHandle(!popupVisible); }, className: [
                BtnName,
                selectedItem ? 'has-value' : '',
                isSelect ? 'select-title-btn' : '',
            ] },
            (selectedItem && selectedItem.name) || title,
            label,
            showIconClose && React.createElement(IconClose, { onClick: function () { return selecthandle(); } }),
            !!showIconDown && React.createElement(IconDown, { style: iconDownStyle, className: iconDownClassName }))));
}
//# sourceMappingURL=single-filter.js.map